export const LibraryIcon = ({ svg }) => {
  return (
    <svg
      className={svg}
      width="22"
      height="17"
      viewBox="0 0 40 40"
      fill={svg}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M37.647 0.941c-2.089-0.659-4.386-0.941-6.588-0.941-3.671 0-7.624 0.753-10.353 2.824-2.729-2.071-6.682-2.824-10.353-2.824s-7.624 0.753-10.353 2.824v27.576c0 0.471 0.471 0.941 0.941 0.941 0.188 0 0.282-0.094 0.471-0.094 2.541-1.224 6.212-2.071 8.941-2.071 3.671 0 7.624 0.753 10.353 2.824 2.541-1.6 7.153-2.824 10.353-2.824 3.106 0 6.306 0.565 8.941 1.976 0.188 0.094 0.282 0.094 0.471 0.094 0.471 0 0.941-0.471 0.941-0.941v-27.482c-1.129-0.847-2.353-1.412-3.765-1.882zM37.647 26.353c-2.071-0.659-4.329-0.941-6.588-0.941-3.2 0-7.812 1.224-10.353 2.824v-21.647c2.541-1.6 7.153-2.824 10.353-2.824 2.259 0 4.518 0.282 6.588 0.941v21.647z"></path>
      <path d="M31.059 11.294c1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.282-3.087-0.452-4.706-0.452-3.2 0-6.099 0.546-8.471 1.562v3.125c2.127-1.205 5.082-1.864 8.471-1.864z"></path>
      <path d="M22.588 15.040v3.125c2.127-1.205 5.082-1.864 8.471-1.864 1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.282-3.087-0.452-4.706-0.452-3.2 0-6.099 0.565-8.471 1.562z"></path>
      <path d="M31.059 18.504c-3.2 0-6.099 0.546-8.471 1.562v3.125c2.127-1.205 5.082-1.864 8.471-1.864 1.656 0 3.256 0.169 4.706 0.489v-2.861c-1.487-0.301-3.087-0.452-4.706-0.452z"></path>
    </svg>
  );
};
